import { Component, OnInit } from '@angular/core';
import { BrokerTableConfig } from "./broker.table-config";
import { AuthService, BrokerService } from '@app/services';
import { ApiResponse } from '@app/interfaces';
@Component({
  selector: 'app-broker-list',
  templateUrl: './broker-list.component.html',
  styleUrls: ['./broker-list.component.scss']
})
export class BrokerListComponent implements OnInit {
  addPanel: boolean = false;
  config: any;
  isLoading: boolean = false;
  dataSource: any = []
  editSelected: any;
  currentUser: any;

  adminEditPanel: boolean = false

  constructor(
    private brokerService: BrokerService,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.config = BrokerTableConfig.configure();
    this.getCurrentUser();
  }

  getCurrentUser() {
    this.authService.me().subscribe({
      next: (res: any) => {
        this.currentUser = res.data
        this.getList();
      }
    })
  }

  getList() {
    this.isLoading = true;
    this.brokerService.list().subscribe({
      next: (res: any) => {
        this.isLoading = false;
        if(this.currentUser.role[0]  == 'Broker Admin') {
          res.data.unshift({
              "deleted": false,
              "_id": this.currentUser.brokerAdmin._id,
              "user": {
                  "isActive": true,
                  "_id": this.currentUser._id,
                  "firstName": this.currentUser.firstName,
                  "lastName": this.currentUser.lastName,
                  "email": this.currentUser.email,
                  "phone": this.currentUser.phone
              },
              "brokerAdmin": this.currentUser.brokerAdmin._id,
              "admin": true
          })
        }
        res.data.forEach((o: any) => {
          o.user.name = `${o.user?.firstName} ${o.user?.lastName ?? ""}`
        })
        this.dataSource = res.data
      }
    })
  }

  action(e: any) {
    this.editSelected = null;
    if (e.button.eventName == "edit") {
      this.editSelected = e.data
      this.addPanel = true;
    }
    if (e.button.eventName == "add") {
      this.addPanel = true;
    }
  }

  onPopupclose() {
    this.addPanel = false
    this.editSelected = null;
    this.getCurrentUser();
  }

}
